import { request } from './client';

export interface AiUsage {
  date: string;
  inputTokens: number;
  outputTokens: number;
  cachedInputTokens: number;
  totalTokens: number;
  requests: number;
  cacheHits: number;
  dailyTokenLimit: number;
  remainingTokens: number | null;
  reservedTokens: number;
  imageRequests: number;
  dailyImageLimit: number;
  remainingImages: number | null;
  failedRequests: number;
  blockedRequests?: number;
}

export function getAiUsage() {
  return request<AiUsage>('/api/ai-usage');
}

export const MAX_AI_DAILY_LIMIT = 2_147_483_647;

export interface AiUsageLimits {
  dailyTokenLimit: number;
  dailyImageLimit: number;
}

export function updateAiUsageLimits(limits: AiUsageLimits) {
  return request<AiUsage>('/api/ai-usage/limits', { method: 'PUT', body: limits });
}

export interface DailyAiUsage {
  date: string;
  recorded: boolean;
  inputTokens: number;
  outputTokens: number;
  cachedInputTokens: number;
  totalTokens: number;
  reservedTokens: number;
  requests: number;
  failedRequests: number;
  blockedRequests: number;
  imageRequests: number;
  cacheHits: number;
}
export function getAiUsageHistory(days: number) {
  return request<DailyAiUsage[]>('/api/ai-usage/history?days=' + days);
}
